import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from 'antd';

import type { NHistoryActionItem } from '@app/components/HistoryActionItem/HistoryActionItem.types';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import type { FC } from 'react';

const { Text } = Typography;

export const HistoryActionItem: FC<NHistoryActionItem.Props> = ({
  index,
  actionItem,
}) => (
  <div className="history-action-item" data-testid="history-action-item">
    {(actionItem.ValueOld || actionItem.ValueNew) && (
      <div className="action-item-container" key={index}>
        <FontAwesomeIcon
          icon={actionItem.Icon as IconProp}
          size={'sm'}
          className="action-item_icon-marker"
        />
        <Text style={{ fontSize: '12px' }}>
          <span data-testid="action-item-old-value">{actionItem.ValueOld}</span>
          {actionItem.ValueOld && (
            <FontAwesomeIcon
              icon={'fa-solid fa-arrow-right' as IconProp}
              size={'sm'}
              className="action-item_icon"
            />
          )}
          <span data-testid="action-item-new-value">{actionItem.ValueNew}</span>
          <Text
            type="secondary"
            style={{ marginLeft: '4px', fontSize: '12px' }}
            data-testid="action-item-property"
          >
            {actionItem.Property}
          </Text>
        </Text>
      </div>
    )}
  </div>
);
